import React from 'react';

import ActiveCallBox from './active-call-box';
import IncomingCallBox from './incoming-call-box';

const VoipPanel = () => {
    return (
        <>
            <IncomingCallBox />
            <ActiveCallBox />
        </>
    );
};

export default VoipPanel;
